import { graphql } from '@frontend/gql/social';

export const discoverInstagramCreators = graphql(`
  query DiscoverInstagramCreators(
    $clientId: String!
    $igUserId: String!
    $query: String
    $limit: Int = 10
    $before: String
    $after: String
    $ageBuckets: [InstagramCreatorAgeBucket!]
    $genders: [InstagramCreatorGender!]
    $countries: [InstagramCreatorCountry!]
    $interests: [InstagramCreatorInterest!]
    $minFollowers: Int
    $maxFollowers: Int
    $minEngagements: Int
    $maxEngagements: Int
    $majorAudienceAgeBuckets: [InstagramCreatorAgeBucket!]
    $majorAudienceGenders: [InstagramCreatorGender!]
    $majorAudienceCountries: [InstagramCreatorCountry!]
    $similarToCreators: [String!]
    $requireInCreatorMarketplace: Boolean
  ) {
    discoverInstagramCreators(
      clientId: $clientId
      igUserId: $igUserId
      filter: {
        query: $query
        ageBuckets: $ageBuckets
        genders: $genders
        countries: $countries
        interests: $interests
        minFollowers: $minFollowers
        maxFollowers: $maxFollowers
        minEngagements: $minEngagements
        maxEngagements: $maxEngagements
        majorAudienceAgeBuckets: $majorAudienceAgeBuckets
        majorAudienceGenders: $majorAudienceGenders
        majorAudienceCountries: $majorAudienceCountries
        similarToCreators: $similarToCreators
        requireInCreatorMarketplace: $requireInCreatorMarketplace
      }
      paging: { limit: $limit, cursors: { after: $after, before: $before } }
    ) {
      creators {
        id
        username
        email
        biography
        ageBucket
        gender
        country
        profilePictureUrl
        insights {
          total {
            followers
          }
          recent {
            engagement
            reach
          }
          daily {
            reach {
              date
              value
            }
          }
        }
        isVerified
        inCreatorMarketplace
      }
      paging {
        cursors {
          after
          before
        }
        hasNext
        hasPrevious
      }
    }
  }
`);

export const getInstagramCreator = graphql(`
  query GetInstagramCreator($clientId: String!, $igUserId: String!, $username: String!) {
    getInstagramCreator(clientId: $clientId, igUserId: $igUserId, username: $username) {
      creator {
        id
        username
        email
        biography
        ageBucket
        gender
        country
        profilePictureUrl
        insights {
          total {
            followers
          }
          recent {
            engagement
            reach
          }
          daily {
            engagement {
              date
              value
            }
            reach {
              date
              value
            }
          }
          audience {
            ageDistribution {
              ageBucket
              percentage
            }
            genderDistribution {
              gender
              percentage
            }
            topCities {
              city
              percentage
            }
            topCountries {
              country
              percentage
            }
          }
        }
        isVerified
        inCreatorMarketplace
        interests
        recentPosts {
          id
          permalink
          caption
          media {
            type
            url
            thumbnailUrl
          }
          insights {
            total {
              likes
              comments
            }
          }
          timestamp
        }
      }
    }
  }
`);

export const suggestInstagramCreatorFilter = graphql(`
  query SuggestInstagramCreatorFilter($prompt: String!) {
    suggestInstagramCreatorFilter(prompt: $prompt) {
      filter {
        username
        query
        ageBuckets
        genders
        countries
        interests
        minFollowers
        maxFollowers
        minEngagements
        maxEngagements
        majorAudienceAgeBuckets
        majorAudienceGenders
        majorAudienceCountries
        similarToCreators
        requireInCreatorMarketplace
      }
    }
  }
`);

export const suggestInstagramCreatorFilters = graphql(`
  query SuggestInstagramCreatorFilters($prompt: String!) {
    suggestInstagramCreatorFilters(prompt: $prompt) {
      queryFilter {
        query
        ageBuckets
        genders
        countries
        interests
        minFollowers
        maxFollowers
        minEngagements
        maxEngagements
        majorAudienceAgeBuckets
        majorAudienceGenders
        majorAudienceCountries
        requireInCreatorMarketplace
      }
      similarToFilters {
        similarToCreators
        ageBuckets
        genders
        countries
        interests
        minFollowers
        maxFollowers
        minEngagements
        maxEngagements
        majorAudienceAgeBuckets
        majorAudienceGenders
        majorAudienceCountries
        requireInCreatorMarketplace
      }
      exactMatchFilters {
        username
      }
    }
  }
`);
